import { styled } from '@mui/system'
import { DataGrid } from '@mui/x-data-grid'

export const StyledDataGrid = styled(DataGrid)`
    border-radius: 4px;
    border: 1px solid rgba(209, 209, 209, 1);
    height: 100%;

    & .MuiDataGrid-columnHeader {
        background-color: rgba(244, 244, 244, 1);
        border: rgba(244, 244, 244, 1) !important;
        border-bottom: 1px solid rgba(209, 209, 209, 1) !important;
    }

    & .MuiDataGrid-main {
        background-color: rgba(255, 255, 255, 1);
    }

    & .MuiDataGrid-columnHeaderTitle {
        font-weight: 700;
    }

    && .MuiDataGrid-cell {
        background-color: rgba(255, 255, 255, 1);
        border-bottom: 1px solid rgba(209, 209, 209, 1);
        display: flex;
        align-items: center;
    }

    & .MuiDataGrid-overlay {
        background-color: rgba(255, 255, 255, 1);
    }

    & .MuiDataGrid-footerContainer {
        background-color: rgba(255, 255, 255, 1);
    }

    & .MuiDataGrid-filler {
        background-color: rgba(255, 255, 255, 1);
    }
    & .MuiDataGrid-columnSeparator {
        color: rgba(209, 209, 209, 1);
        background-color: rgba(244, 244, 244, 1);
        border-bottom: 0.5px solid rgba(209, 209, 209, 1) !important;
        height: 50px !important;
        &:hover {
            color: rgba(0, 111, 214, 1);
        }
    }
    & .MuiDataGrid-columnSeparator--resizable {
        border: 0px solid rgba(209, 209, 209, 1);
        max-height: 50px;
    }

    & .MuiDataGrid-sortIcon {
        color: #000000;
    }

    & .MuiIconButton-root {
        color: #4c4747;
    }
`
